import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-anurag',
  templateUrl: './anurag.component.html',
  styleUrls: ['./anurag.component.scss']
})
export class AnuragComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getAnurag();
  }

}
